const STUDENT_HISTORY_VIEW = 'STUDENT_HISTORY_VIEW';
const CUSTOM_SMS = 'CUSTOM_SMS';

export { STUDENT_HISTORY_VIEW, CUSTOM_SMS };
